<template>
  <div>
    <HMModalHeader :title="$t(titleKey)" @close="$emit('close')" />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="confirm" v-if="taxRateModel">
        <div class="row">
          <div class="col-12">
            <HMTextInput
              :label="$t('PRODUCTS.TAX_RATES.NAME')"
              v-model="taxRateModel.name"
              rules="required"
              name="Tax rate name"
            />
          </div>
          <div class="col-12">
            <HMTextInput
              :label="$t('PRODUCTS.TAX_RATES.RATE')"
              v-model="taxRateModel.rate"
              :rules="{ required: true, regex: /^\d*\.?\d*$/ }"
              name="Rate (percent)"
            >
              <template slot="prepend">
                <span>%</span>
              </template>
            </HMTextInput>
          </div>
          <div class="col-12 d-flex justify-content-between align-items-center">
            <div>
              {{ $t('GENERAL.LABEL.ACTIVE') }}
            </div>
            <div>
              <HMSwitch v-model="taxRateModel.active" />
            </div>
          </div>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SAVE')"
          :disabled="invalid"
          :formError="formError"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'TaxRateDialog',
  components: {
    ValidationObserver,
  },
  props: {
    taxRate: {
      type: Object,
      default() {
        return {
          name: '',
          rate: 0.0,
          active: true,
        };
      },
    },
    onConfirm: null,
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
    }),
    titleKey() {
      return this.taxRateModel?.id
        ? 'PRODUCTS.TITLE.EDIT_TAX_RATE'
        : 'PRODUCTS.TITLE.ADD_TAX_RATE';
    },
  },
  data() {
    return {
      taxRateModel: null,
      formError: null,
    };
  },
  methods: {
    confirm() {
      this.onConfirm(this.taxRateModel);
      this.$emit('close');
    },
  },
  mounted() {
    this.taxRateModel = cloneDeep(this.taxRate);
  },
  watch: {
    'taxRateModel.rate': {
      handler(rate) {
        if (rate && this.taxRateModel.stripe_id) {
          this.taxRateModel.stripe_id = null;
        }
      },
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.clickable {
  cursor: pointer;
  color: $medium-gray;
  &:hover {
    color: var(--brand-color, $coral);
  }
}

.info-box {
  border-radius: $border-radius;
  background-color: lighten($blue, 30%);
  padding: 0.5rem;

  .info {
  }
}
</style>
